import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";

export default function Legal({ type }) {
  const { copy } = useLanguage();
  const isPrivacy = type === "privacy";
  const title = isPrivacy ? copy.legal.privacyTitle : copy.legal.cookiesTitle;
  const sections = isPrivacy ? copy.legal.privacy : copy.legal.cookies;

  return (
    <main className="pt-28 pb-24 sm:pt-36" data-testid={`${type}-page`}>
      <Seo title={isPrivacy ? copy.seo.privacy.title : copy.seo.cookies.title} description={isPrivacy ? copy.seo.privacy.desc : copy.seo.cookies.desc} />
      <div className="max-w-3xl mx-auto px-5">
        <Reveal>
          <h1 className="font-serif font-semibold text-4xl sm:text-5xl text-ink tracking-tight" data-testid={`${type}-title`}>{title}</h1>
          <p className="mt-3 text-xs font-mono uppercase tracking-widest text-muted">{copy.legal.updated}</p>
        </Reveal>
        <div className="mt-12 space-y-8">
          {sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <section data-testid={`${type}-section-${i}`}>
                <h2 className="font-serif font-semibold text-xl text-pine mb-2">{s.h}</h2>
                <p className="text-muted leading-relaxed text-sm sm:text-base">{s.p}</p>
              </section>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
}
